function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", null, React.createElement("path", {
  className: "st0",
  d: "M57.1,24.1C57.1,24.1,57.1,24.2,57.1,24.1L57.1,24.1c-4,4-6.5,9.5-6.5,15.6c0,5,1.7,9.6,4.5,13.3 c0,0,0.1,0.1,0.1,0c0,0,0-0.1,0-0.1c-1.7-5.2,6.9-17.7,11.3-22.9c0,0,0,0,0-0.1c0,0,0-0.1,0-0.1C59.1,22.5,57.1,24.2,57.1,24.1"
}), React.createElement("path", {
  className: "st0",
  d: "M87.9,24.1C87.9,24.1,87.9,24.2,87.9,24.1L87.9,24.1c4,4,6.5,9.5,6.5,15.6c0,5-1.7,9.6-4.5,13.3 c0,0-0.1,0.1-0.1,0c0,0,0-0.1,0-0.1c1.7-5.2-6.9-17.7-11.3-22.9c0,0,0,0,0-0.1c0,0,0-0.1,0-0.1C86,22.5,87.9,24.2,87.9,24.1"
}), React.createElement("path", {
  className: "st0",
  d: "M72.5,17.8c4.4,0,8.1,1.2,11.4,3.2c0,0,0.1,0.1,0,0.1c0,0-0.1,0-0.1,0c-4.2-0.9-10.7,2.7-11.3,3.1c0,0,0,0,0,0 c0,0,0,0,0,0c-1.6-0.9-7.6-4.1-11.3-3.1c0,0-0.1,0-0.1,0c0,0,0-0.1,0-0.1C64.4,19,68.1,17.8,72.5,17.8"
}), React.createElement("path", {
  className: "st0",
  d: "M72.5,35.4C72.5,35.4,72.6,35.4,72.5,35.4c6.6,5,17.9,17.3,14.4,20.8l0,0c0,0,0,0,0,0h0 c-3.9,3.4-8.9,5.4-14.4,5.4c-5.5,0-10.6-2-14.4-5.4l0,0c0,0,0,0,0,0l0,0C54.7,52.8,65.9,40.4,72.5,35.4 C72.4,35.4,72.5,35.4,72.5,35.4"
}));

var SvgLogoXbox = function SvgLogoXbox(props) {
  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 145 80",
    style: {
      enableBackground: "new 0 0 145 80"
    },
    xmlSpace: "preserve"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/logo-xbox.7cb0bda9.svg";
export { SvgLogoXbox as ReactComponent };